import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import Tattoo1 from "./Tattoo1.jpg";
import Luciana1 from "./Luciana.jpg";
import Luciana2 from "./Luciana2.jpg";
import videoCurso from "../../assets/CursoVideo.mp4";
import { NavLink } from "react-router-dom";

const HeroTattooOpciones = () => {
  const images = [Luciana1, Tattoo1, Luciana2];

  const [currentImage, setCurrentImage] = useState(0);
  const [showNav, setShowNav] = useState(false);
  const [modalTurnos, setModalTurnos] = useState(false);

  const phoneNumber = "5492235453354";

  const navHandler = () => setShowNav(!showNav);

  /* ROTACION AUTOMATICA DE IMAGENES MOBILE */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  /* WHATSAPP */
  const enviarWhatsapp = (tipo) => {
    let message = "";

    if (tipo === "cuadros") {
      message =
        "Hola Luciana! Estoy interesado/a en comprar tus cuadros. ¿Me podés pasar más info?";
    }

    if (tipo === "turno") {
      message =
        "Hola Luciana! Quisiera consultar por un tatuaje.\n\n" +
        "Tamaño aproximado:\n" +
        "Zona del cuerpo:\n" +
        "Foto de referencia:";
    }

    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_blank");
  };

  return (
    <>
      <section
        className="relative min-h-screen flex flex-col items-center justify-center p-6 
        pt-[calc(var(--navbar-height,4rem)+1rem)] overflow-hidden"
        id="hero-tattoo"
      >
        {/* BACKGROUND MOBILE CON TRANSICION */}
        <div className="absolute inset-0 md:hidden -z-10 overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.img
              key={currentImage}
              src={images[currentImage]}
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1.2 }}
              className="absolute inset-0 w-full h-full object-cover"
            />
          </AnimatePresence>

          <div className="absolute inset-0 bg-black/60"></div>
        </div>

        {/* VIDEO DESKTOP */}
        <div className="absolute inset-0 w-full h-full overflow-hidden -z-10 hidden md:block">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute top-0 left-0 w-full h-full object-cover"
          >
            <source src={videoCurso} type="video/mp4" />
          </video>

          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        {/* CONTENIDO */}
        <div className="relative z-10 max-w-7xl w-full grid grid-cols-1 md:grid-cols-2 gap-12 items-center text-white">

          {/* TEXTO */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6 text-center md:text-left"
          >
            <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight drop-shadow-lg">
              <br />
              <span className="text-[#d7b48a]">Luciana Avalos Tattoo</span>
            </h1>

            <p className="text-lg max-w-md mx-auto md:mx-0 drop-shadow-md">
              Reservá tu turno, aprendé a tatuar o llevate una obra original.
            </p>

            {/* BOTONES */}
            <div className="pt-2 flex flex-col gap-3 sm:flex-row flex-wrap justify-center md:justify-start">

              <motion.button
                whileHover={{ scale: 1.05 }}
                onClick={() => setModalTurnos(true)}
                className="px-6 py-3 border-2 border-[#d7b48a] text-[#d7b48a] rounded-full font-semibold 
                hover:bg-[#d7b48a] hover:text-black transition shadow-lg"
              >
                Turnos y presupuestos
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.05 }}
                className="px-6 py-3 border-2 border-[#d7b48a] text-[#d7b48a] rounded-full font-semibold 
                hover:bg-[#d7b48a] hover:text-black transition shadow-lg"
              >
                <NavLink to="/curso" onClick={navHandler} className="block">
                  Curso de tatuaje
                </NavLink>
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.05 }}
                onClick={() => enviarWhatsapp("cuadros")}
                className="px-6 py-3 border-2 border-[#d7b48a] text-[#d7b48a] rounded-full font-semibold 
                hover:bg-[#d7b48a] hover:text-black transition shadow-lg"
              >
                Comprar cuadros
              </motion.button>

            </div>
          </motion.div>

          {/* GALERIA DESKTOP */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="hidden md:grid grid-cols-3 gap-4"
          >
            {images.map((src, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05, rotate: 1 }}
                transition={{ type: "spring", stiffness: 100 }}
                className="relative h-[420px] overflow-hidden rounded-xl shadow-xl"
              >
                <img
                  src={src}
                  alt={`imagen-${index + 1}`}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </motion.div>
            ))}
          </motion.div>

        </div>
      </section>

      {/* MODAL TURNOS */}
      <AnimatePresence>
        {modalTurnos && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-md p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setModalTurnos(false)}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
              className="bg-[#0f0f0f] text-white max-w-lg w-full rounded-2xl 
              p-8 border border-[#d7b48a]/40 shadow-2xl relative"
            >
              <button
                onClick={() => setModalTurnos(false)}
                className="absolute top-4 right-4 text-xl opacity-70 hover:opacity-100"
              >
                ✕
              </button>

              <h2 className="text-2xl font-bold text-[#d7b48a] mb-4 text-center">
                Turnos y Presupuestos
              </h2>

              <p className="text-center mb-4">
                ¿Qué necesitamos para darte un turno o un presupuesto?
              </p>

              <div className="bg-black/40 rounded-lg p-4 mb-6">
                <p className="text-sm mb-3">
                  Para cotizar tu tatuaje necesitamos esta información:
                </p>

                <ul className="text-sm space-y-2 opacity-90">
                  <li>• Tamaño aproximado del tatuaje</li>
                  <li>• Zona del cuerpo</li>
                  <li>• Foto de referencia</li>
                </ul>
              </div>

              <motion.button
                whileHover={{ scale: 1.05 }}
                onClick={() => enviarWhatsapp("turno")}
                className="w-full py-4 mb-3 bg-[#d7b48a] text-black font-bold 
                rounded-full shadow-lg hover:brightness-110"
              >
                ¿Ya tenés esta información? Cotizá tu idea y tatuate ahora!
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.05 }}
                onClick={() => enviarWhatsapp("turno")}
                className="w-full py-3 border-2 border-[#d7b48a] text-[#d7b48a] 
                rounded-full font-semibold hover:bg-[#d7b48a] hover:text-black"
              >
                Quiero sacar un turno
              </motion.button>

            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default HeroTattooOpciones;